var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-tooltip', { attrs: { "placement": _vm.tipsPlacement, "trigger": "hover", "content": _vm.$t('playTurbo.common.to-helper') } }, [_c('span', { staticClass: "to-helper", on: { "click": function click($event) {
        return _vm.toHelperPage();
      } } }, [_c('svg-icon', { attrs: { "icon-class": "helpcenter", "size": 24 } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };